import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * Service untuk mengelola Fuel Type
 * @namespace FuelTypeSvc
 */
export default {
  /**
   * Mendapatkan semua data Fuel Type
   * @function getFuelType
   * @return {Promise} Promise yang berisi response dari server
   */
  getFuelType: async (params) => {
    const { data } = await axiosInstance.get('/master/fuel_type', {
      params: {
        ...params,
      },
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mendapatkan data Fuel Type berdasarkan ID
   * @function getFuelTypeById
   * @param {number} id - ID dari Fuel Type yang ingin di dapatkan
   * @return {Promise} Promise yang berisi response dari server
   */
  getFuelTypeById: async (id) => {
    const { data } = await axiosInstance.get(`/master/fuel_type/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Membuat data Fuel Type baru
   * @function createFuelType
   * @param {object} data - Data yang ingin di buat
   * @return {Promise} Promise yang berisi response dari server
   */
  createFuelType: async (fuelTypeData) => {
    const { data } = await axiosInstance.post('/master/fuel_type', fuelTypeData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Mengupdate data Fuel Type yang sudah ada
   * @function updateFuelType
   * @param {number} id - ID dari Fuel Type yang ingin di update
   * @param {object} data - Data yang ingin di update
   * @return {Promise} Promise yang berisi response dari server
   */
  updateFuelType: async (id, fuelTypeData) => {
    const { data } = await axiosInstance.put(`/master/fuel_type/${id}`, fuelTypeData, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
  /**
   * Menghapus data Fuel Type yang sudah ada
   * @function deleteFuelType
   * @param {number} id - ID dari Fuel Type yang ingin di hapus
   * @return {Promise} Promise yang berisi response dari server
   */
  deleteFuelType: async (id) => {
    const { data } = await axiosInstance.delete(`/master/fuel_type/${id}`, {
      cancelToken: getNewCancelToken(),
    });
    return data;
  },
};
